import React from 'react';

const points = [
    [120, 180], [320, 110], [540, 240], [760, 150],
    [980, 230], [1210, 130], [1360, 330], [1120, 450],
    [870, 400], [620, 500], [380, 420], [150, 540],
    [460, 720], [730, 640], [1010, 700], [1290, 610]
];

const connections = [
    [0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [6, 7], [7, 8],
    [8, 9], [9, 10], [10, 11], [11, 0], [0, 10], [2, 10], [2, 9],
    [3, 8], [4, 7], [4, 8], [7, 14], [9, 13], [11, 12], [12, 13],
    [13, 14], [14, 15], [15, 6], [5, 7], [1, 10], [9, 13], [13, 14],
    [12, 9], [8, 13]
];

const TechOverlay = () => (
    <div className="tech_overlay" aria-hidden="true">
        <div className="tech_grid"></div>
        <svg
            className="tech_network"
            viewBox="0 0 1440 900"
            preserveAspectRatio="xMidYMid slice"
        >
            <defs>
                <linearGradient id="techLineGradient" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#22d3ee"/>
                    <stop offset="55%" stopColor="#3b82f6"/>
                    <stop offset="100%" stopColor="#a855f7"/>
                </linearGradient>
            </defs>
            <g className="tech_lines" stroke="url(#techLineGradient)">
                {connections.map(([from, to], index) => (
                    <line
                        key={`${from}-${to}-${index}`}
                        x1={points[from][0]}
                        y1={points[from][1]}
                        x2={points[to][0]}
                        y2={points[to][1]}
                    />
                ))}
            </g>
            <g className="tech_nodes">
                {points.map(([x, y], index) => (
                    <circle key={`${x}-${y}`} cx={x} cy={y} r="3.5"/>
                ))}
            </g>
        </svg>
        <div className="tech_scan"></div>
    </div>
);

export default TechOverlay;
